'use strict';

// Disabled until we stop loading jQuery globally
// import $ from 'jQuery';

$('.js-nested').on('change', 'input', function () {
    const input = $(this);

    // Remove all open nests
    input.closest('.js-nested')
            .find('.o-form__nested')
            .removeClass('o-form__nested--active');

    // open the nest if we have one
    input.closest('.o-form__nested').addClass('o-form__nested--active');
});



// WEBPACK FOOTER //
// ./src/js/components/nested-form.js